<script>
  import AccordionItem from "$lib/components/AccordionItem.svelte";
  import Bleed from "$lib/components/Bleed.svelte";
  export let highTierContributors;
</script>

<Bleed fullWidth>
  <div class="w-full pt-32 pb-48 md:py-72 md:w-3/5 lg:w-806 m-auto">
    {#each highTierContributors as tier}
      <AccordionItem label={tier.category} isOpen={false}>
        <div class="py-4">
          {#each tier.contributors as contributor}
            <p>{contributor.name}</p>
          {/each}
        </div>
      </AccordionItem>
    {/each}
  </div>
</Bleed>
